let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("erj8t")).then(() => parcelRequire('amxqt'));